export enum NEWSLETTER {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=7244388
     */
    NEWSLETTER_KEY = 'ADMIN.NAV.NEWSLETTER',
}
